import { CancelIconButton, DeleteIconButton } from "@compass/core";
import { FilePanel, InlineEditDataModel } from "components";
import { Permission, PermissionAction, StudentServiceFile, UploadFile } from "generated/openApi";
import { useInlineEditDataModel } from "hooks";
import produce from "immer";
import "moment-timezone";
import { isAuthorized } from "services";
import { initDataModel } from "utils";

export const ServiceFile = (props: {
  rootPermission: Permission;
  serviceFile: StudentServiceFile;
  setServiceFile: (serviceFile: StudentServiceFile) => void;
  cancelCreate: () => void;
}) => {
  const { removing, canCancel, canRemove, cancel, remove } = useInlineEditDataModel({
    dataModel: props.serviceFile,
    setDataModel: props.setServiceFile,
    cancelCreate: props.cancelCreate,
  });

  return (
    <InlineEditDataModel
      noPadding
      overflow="auto"
      actions={
        <>
          {isAuthorized(props.rootPermission, PermissionAction.Delete) && canRemove && (
            <DeleteIconButton onClick={remove} size="small" />
          )}
          {canCancel && <CancelIconButton onClick={cancel} size="small" />}
        </>
      }
      content={
        <FilePanel
          border={false}
          fileName={props.serviceFile.uploadFile.fileName}
          fileRef={props.serviceFile.uploadFile.fileRef}
          fileSize={props.serviceFile.uploadFile.fileSize}
          uploadingData={props.serviceFile.uploadFile?.uploadingData}
          imagePreviewData={props.serviceFile.uploadFile?.imagePreviewData}
          onFileChange={(fileName, fileSize, uploadingData) => {
            props.setServiceFile(
              produce(props.serviceFile, (draft) => {
                draft.uploadFile = initDataModel<UploadFile>({
                  fileName: fileName,
                  fileSize: fileSize,
                  uploadingData: uploadingData,
                });
              })
            );
          }}
        />
      }
      removing={removing}
    />
  );
};
